export const iconFontAwesomeReligionAtom = (
	<i className="fa-solid fa-atom"></i>
);
